HuesMdl.service( 'HuesUpdaterSrv', [ function () {

	return {

		hideHues: false,
		getHues: false,
		isSearch: false,
		hasHues: false,
		current_color: 'yellow'
	}
}]);
